import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Card, Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faSpinner, faCloud } from '@fortawesome/free-solid-svg-icons';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const { verifyEmail } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const email = searchParams.get('email');

    if (!token || !email) {
      setLoading(false);
      setError('Invalid verification link. Missing token or email.');
      return;
    }

    const verifyUserEmail = async () => {
      try {
        const response = await verifyEmail(token, email);

        if (response.status === 200) {
          if (response.data?.already_verified) {
            setMessage('Your email is already verified.');
          } else {
            setVerified(true);
            setMessage('Your email has been verified successfully!');
          }
        } else {
          setError(response.message || 'Verification failed');
        }
      } catch (err) {
        setError('An unexpected error occurred during verification');
      } finally {
        setLoading(false);
      }
    };

    verifyUserEmail();
  }, [searchParams, verifyEmail]);

  return (
    <div className="verify-container">
      <Container>
        <Row className="justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
          <Col md={8} lg={7} xl={6}>
            <Card className="verify-card">
              <div className={`verify-header text-center ${verified ? 'success' : error ? 'error' : ''}`}>
                <FontAwesomeIcon icon={faCloud} className="cloud-icon" />
                <div className="brand-name">
                  <FontAwesomeIcon icon={faCloud} className="brand-name-icon" />
                  <h1>Vcurd Document Review</h1>
                </div>
                {/* <div className="app-name">Cloud Document Management System</div> */}
              </div>
              
              <div className="verify-body">
                {loading ? (
                  <div className="my-5">
                    <FontAwesomeIcon icon={faSpinner} spin className="status-icon loading" />
                    <h2>Verifying Your Email</h2>
                    <p className="text-muted">Please wait while we verify your email address...</p>
                  </div>
                ) : verified || message ? (
                  <div className="my-5">
                    <FontAwesomeIcon icon={faCheckCircle} className="status-icon success" />
                    <h2>Verification Successful!</h2>
                    <div className="success-message">
                      <p>{message || 'Your email has been verified successfully!'}</p>
                    </div>
                    <p className="mb-4">You can now log in to your account and access all features of the Document Review System.</p>
                    <Button 
                      className="verify-btn" 
                      onClick={() => navigate('/login')}
                    >
                      <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                      Go to Login
                    </Button>
                  </div>
                ) : (
                  <div className="my-5">
                    <FontAwesomeIcon icon={faTimesCircle} className="status-icon error" />
                    <h2>Verification Failed</h2>
                    <div className="error-message">
                      <p>{error || 'The verification link is invalid or has expired.'}</p>
                    </div>
                    <p className="mb-4">
                      Please request a new verification email to complete your account setup.
                    </p>
                    <Button 
                      className="verify-btn"
                      onClick={() => navigate('/verification-pending')}
                    >
                      Request New Verification
                    </Button>
                  </div>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyEmail;
